import { SimulationTrackerStatusMessage } from 'src/app/predictor/enums/simulation-tracker-status';
import { Component, ViewChild } from '@angular/core';
import { SimulationTrackerService } from '../../services/simulation-tracker.service';
import { SimulationTrackerUserUsageReport } from '../../interfaces/simulation-tracker-user-usage-report';
import { Observable } from 'rxjs';
import { Table } from 'primeng/table';
import { SimulationTrackerStatusCount } from '../../interfaces/simulation-tracker-status-count';
import { SimulationTrackerDataService } from '../../services/simulation-tracker-data.service';

@Component({
  selector: 'app-simulation-tracker-report-page',
  templateUrl: './simulation-tracker-report-page.component.html',
})
export class SimulationTrackerReportPageComponent {
  usageReport$: Observable<SimulationTrackerUserUsageReport[]>;
  statusSummary$: Observable<SimulationTrackerStatusCount[]>;

  constructor(private simulationTrackerService: SimulationTrackerService) {
    this.usageReport$ =
      this.simulationTrackerService.getSimulationTrackerUsage();
    this.statusSummary$ = this.simulationTrackerService
      .getSimulationTrackerStatusReport()
  }

  public GetStatusDisplay(status: SimulationTrackerStatusMessage): any {
    return SimulationTrackerDataService.GetStatusDisplay(status);
  }

  /**
   * Number of rows per page.
   */
  rows: number = 20;

  /**
   * Paginator dropdown options.
   */
  paginatorDropdownOptions = [5, 10, 20, 30, 50];

  @ViewChild(Table) private table!: Table;
}
